// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/Signup";
import HomePage from "./components/Home";
import Header from "./components/auth/Header";
import Welcome from "./components/Welcome";
import ProtectedRoute from "./components/ProtectedRoutes";
import SchedulePage from "./components/Schedule/SchedulePage";
import { NightModeProvider } from './components/NightModeContext'; 
import { TaskProvider } from "./components/Schedule/TaskContext";


function App() {
  return (
    <Router>
      <TaskProvider>
        <NightModeProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            <Route path="/schedule" element={<ProtectedRoute><SchedulePage /></ProtectedRoute>} /> 
            <Route path="*" element={<Welcome />} />
          </Routes>
        </NightModeProvider>
      </TaskProvider>
    </Router>
  );
}

export default App;
